import axios from 'axios';
import UtilDate from './UtilDate';
import UtilNotify from './UtilNotify';
import UtilNumber from './UtilNumber';
import ApiStorage from '../redux/ApiStorage';

let BASE_URL = process.env.REACT_APP_BASE_NODE_URL;
console.warn('BASE_URL :>> ', BASE_URL);

export const getBaseURL = () => {
  return `${BASE_URL}/api/v4/`;
};

export const getBaseURLShowImage = (src) => {
  const iconSrc = src
    ? src.startsWith('http')
      ? src
      : `${process.env.REACT_APP_DO_SPACES_READ_URL}/${src}`
    : '';
  return iconSrc;
};

const adapter = axios.create({
  baseURL: getBaseURL(),
  headers: {
    Accept: 'application/json;charset=UTF-8',
    'Content-Type': 'application/json',
  },
  validateStatus: false,
  withCredentials: false,
  timeout: 90000,
});

export async function fetchFromUrlPOSTAsync(url, parameters = []) {
  return await fetchFromUrlPOSTAsyncMain(url, parameters, {});
}

export async function fetchFromUrlPOSTAsyncLong(url, parameters = []) {
  return await fetchFromUrlPOSTAsyncMain(url, parameters, { timeout: 600000 });
}

export async function fetchFromUrlPOSTAsyncUploadFile(url, file = []) {
  try {
    let deviceKey = ApiStorage.getDeviceKey();
    if (!deviceKey) {
      ApiStorage.setDeviceKey(UtilNumber.getNewUniqID());
      deviceKey = ApiStorage.getDeviceKey();
    }

    const formData = new FormData();
    formData.append('image', file);
    formData.append('device', 'web');
    formData.append('offset', getTimeZone());
    formData.append('deviceKey', deviceKey);

    const response = await axios.post(getBaseURL() + url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        authorization: `Bearer ${ApiStorage.getAccessToken()}`,
      },
    });
    return response.data;
  } catch (error) {
    UtilNotify.notifyErrorServer(error.message);
    // window.location.reload();
    return { success: false, errMsg: error.message };
  }

  // return await fetchFromUrlPOSTAsyncMain(url, parameters, { timeout: 600000 });
}

export async function fetchFromUrlPOSTAsyncDownloadFile(
  url,
  parameters = [],
  fileName
) {
  const response = await fetchFromUrlPOSTAsyncMain(url, parameters, {
    responseType: 'blob',
    headers: {
      Accept: '*/*', // ✅ allow any type
      'Content-Type': 'application/json', // only if server requires JSON body
    },
  });

  if (response.hasOwnProperty('errMsg')) {
    return response;
  }

  const blob = new Blob([response], { encoding: 'UTF-8' });
  // const blob = await response.blob();
  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);

  // if (!fileName) {
  //   const nam = UtilDate.getDateToday().format("DD-MM-YYYY_HH-MM-ss");
  //   if (response.type === "text/plain") {
  //     fileName = `${nam}.txt`;
  //   } else if (
  //     response.type ===
  //     "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  //   ) {
  //     fileName = `${nam}.xlsx`;
  //   } else if (response.type === "application/xml") {
  //     fileName = `${nam}.xml`;
  //   }
  // }

  const contentType = response.headers?.get('content-type') || response.type;

  if (!fileName) {
    const nam = UtilDate.getDateToday().format('DD-MM-YYYY_HH-MM-ss');

    if (contentType.includes('pdf')) {
      fileName = `${nam}.pdf`;
    } else if (contentType.includes('sheet')) {
      fileName = `${nam}.xlsx`;
    } else if (contentType.includes('xml')) {
      fileName = `${nam}.xml`;
    } else if (contentType.includes('txt')) {
      fileName = `${nam}.txt`;
    } else {
      fileName = `${nam}`;
    }
  }

  link.download = fileName;
  document.body.appendChild(link);
  link.click();

  // Cleanup
  setTimeout(() => {
    document.body.removeChild(link);
    window.URL.revokeObjectURL(link.href);
  }, 100);

  return response;
}

export async function previewPdfInNewTab(url, parameters = []) {
  try {
    const response = await fetchFromUrlPOSTAsyncMain(url, parameters, {
      responseType: 'blob',
    });

    if (response.hasOwnProperty('errMsg')) {
      return response;
    }

    const blob = new Blob([response], { type: 'application/pdf' });
    const pdfUrl = URL.createObjectURL(blob);

    // Open in new tab
    const newWindow = window.open();
    if (newWindow) {
      newWindow.document.write(`
        <!DOCTYPE html>
        <html>
          <head>
            <title>PDF Preview</title>
            <style>
              body, html { margin: 0; padding: 0; height: 100%; }
              embed { width: 100%; height: 100%; border: none; }
            </style>
          </head>
          <body>
            <embed src="${pdfUrl}" type="application/pdf">
          </body>
        </html>
      `);

      // Clean up when window closes
      newWindow.onbeforeunload = () => {
        URL.revokeObjectURL(pdfUrl);
      };
    } else {
      // Fallback if popup is blocked
      const link = document.createElement('a');
      link.href = pdfUrl;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Clean up after some time
      setTimeout(() => {
        URL.revokeObjectURL(pdfUrl);
      }, 10000);
    }

    return true;
  } catch (error) {
    console.error('Preview failed:', error);
    return { errMsg: error.message };
  }
}

export async function printPdfFromUrl(url, parameters = []) {
  try {
    const response = await fetchFromUrlPOSTAsyncMain(url, parameters, {
      responseType: 'blob',
    });

    if (response.hasOwnProperty('errMsg')) {
      return response;
    }

    const blob = new Blob([response], { type: 'application/pdf' });
    const pdfUrl = URL.createObjectURL(blob);
    const iframe = document.createElement('iframe');
    let cleanupTimeout;

    const cleanup = () => {
      window.clearTimeout(cleanupTimeout);
      URL.revokeObjectURL(pdfUrl);
      iframe.remove();
    };

    iframe.title = 'PDF print';
    iframe.style.position = 'fixed';
    iframe.style.right = '0';
    iframe.style.bottom = '0';
    iframe.style.width = '1px';
    iframe.style.height = '1px';
    iframe.style.border = '0';
    iframe.style.opacity = '0';
    iframe.onload = () => {
      const printWindow = iframe.contentWindow;
      if (!printWindow) {
        cleanup();
        return;
      }
      printWindow.onafterprint = cleanup;
      printWindow.focus();
      printWindow.print();
      cleanupTimeout = window.setTimeout(cleanup, 60000);
    };
    iframe.src = pdfUrl;
    document.body.appendChild(iframe);

    return true;
  } catch (error) {
    return { errMsg: error.message };
  }
}

export async function fetchFromUrlPOSTAsyncMain(
  url,
  parameters = [],
  adapterOptions
) {
  try {
    let deviceKey = ApiStorage.getDeviceKey();
    if (!deviceKey) {
      ApiStorage.setDeviceKey(UtilNumber.getNewUniqID());
      deviceKey = ApiStorage.getDeviceKey();
    }

    let dataPost = {
      device: 'web',
      offset: getTimeZone(),
      deviceKey: deviceKey.toString(),
    };

    if (Array.isArray(parameters)) {
      parameters.forEach((par) => {
        dataPost[par.key] = par.value;
      });
    } else {
      Object.assign(dataPost, parameters);
    }

    let token = ApiStorage.getAccessToken();
    if (token) {
      adapter.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    } else {
      delete adapter.defaults.headers.common['Authorization'];
    }
    let result = await adapter.post(url, dataPost, adapterOptions);
    if (result.status === 401) {
    } else if (result.status === 410) {
      ApiStorage.clearUser();
      window.location.replace('/en/login');
    } else if (result.status === 500) {
      UtilNotify.notifyErrorServer(result.statusText);
      return { success: false, errMsg: result.statusText };
    }
    return result.data;
  } catch (error) {
    console.warn('error = ', error);
    UtilNotify.notifyErrorServer(error.message);
    return { success: false, errMsg: error.message };
  }
}

export async function fetchFromUrlGETAsync(url, parameters = []) {
  try {
    let dataPost = {
      device: 'web',
      offset: getTimeZone(),
    };

    parameters.forEach((par) => {
      dataPost[par.key] = par.value;
    });
    let token = ApiStorage.getAccessToken();
    if (token) {
      adapter.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    } else {
      delete adapter.defaults.headers.common['Authorization'];
    }
    let result = await adapter.get(url, {
      params: dataPost,
    });
    return result.data;
  } catch (error) {
    console.warn('error = ', error);
    return { success: false, errMsg: error.message };
  }
}

function getTimeZone() {
  let offset = new Date().getTimezoneOffset();
  const result = `+${Math.abs(offset)}`;
  return result;
}

export async function downloadFile(url) {
  // const response = await axios({
  //   url: url,
  //   method: "GET",
  //   // headers: headers,
  //   headers: {
  //     Accept: "application/json;charset=UTF-8",
  //     "Content-Type": "application/xml",
  //   },
  //   responseType: "blob" // important
  // })
  const adapter = axios.create({
    baseURL: process.env.REACT_APP_BASE_NODE_URL,
    headers: {
      Accept: 'application/json;charset=UTF-8',
      'Content-Type': 'application/json',
    },
    validateStatus: false,
    withCredentials: false,
    timeout: 90000,
  });

  let response = await adapter.get(url, {
    responseType: 'blob',
  });

  console.warn('response :>> ', response);
  // const url = window.URL.createObjectURL(new Blob([response.data]));
  // const link = document.createElement("a");
  // link.href = url;
  // link.setAttribute(
  //   "download",
  //   `${this.props.file.name}.${this.props.file.mime}`
  // );
  // document.body.appendChild(link);
  // link.click();

  // // Clean up and remove the link
  // link.parentNode.removeChild(link);
}

export default adapter;
